import config from 'config';
import * as types from '../actions/types';
import axios from 'axios';
import * as request from '../utils/request';
import { customHeader } from '../utils/request';
import toastr from 'toastr';
import { browserHistory } from 'react-router';
import { getSchool } from './schoolActionCreators';
import mergeRequestsWrapper from './mergeRequestsWrapper'
var baseUrl = config.baseUrl;

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
};

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
};

export function getRunSuccess(response) {
  return {
    type: types.GET_RUN_SUCCESS,
    payload: response.data
  };
}

export function runsFetched(data) {
  return {
    type: types.RUNS_FETCHED,
    payload: data
  };
}

export function getRankPreferencesSuccess(preferences) {
  return {
    type: types.GET_ALL_RANK_PREFERENCES_SUCCESS,
    payload: preferences
  };
}

export function getAllocationsSuccess(allocations) {
  return {
    type: types.GET_ALLOCATIONS_SUCCESS,
    payload: allocations
  };
}

export function getFinishedComputationsSuccess(computations) {
  return {
    type: types.GET_FINISHED_COMPUTATIONS_SUCCESS,
    payload: computations
  };
}

export function getFinishedComputations(/*computationId*/) {
  let runName = localStorage.getItem('run');

  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', '/runs/' + runName + '/computations/')
        .then(res => {
          const finishedComputations = res.data ? res.data.results.filter(item => item.status === 'finished') : [];
          dispatch(getFinishedComputationsSuccess(finishedComputations));
        })
        .catch(err => {
          console.log(err.message);
          return reject();
        });
    });
    return promise;
  };
}

export function getComputation(computationId) {
  let runName = localStorage.getItem('run');

  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', '/runs/' + runName + '/computations/' + computationId + '/')
        .then(res => {
          return resolve(res.data);
        })
        .catch(err => {
          console.log(err.message);
          return reject();
        });
    });
    return promise;
  };
}

export function startElicitation() {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/start-elicitation/')
        .then(() => {
          toastr.success('Elicitation has started successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('ERROR', err.message);
          toastr.error('Problem with starting the Elicitation!');
          return reject();
        });
    });

    return promise;
  };
}

export function stopElicitation() {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/stop-elicitation/')
        .then(() => {
          toastr.success('Elicitation has stopped successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('ERROR', err.message);
          toastr.error('Problem with stopping the Elicitation!');
          return reject();
        });
    });

    return promise;
  };
}

export function continueStartRun(statusUrl) {
  return () => {
    let promise = new Promise((resolve, reject) => {
      let time = +localStorage.getItem('assignTime');

      function checkStatus(url) {
        request.req('GET', url).then(res => {
          if (res.data.status == 'success') {
            toastr.success('Assignment has started successfully!');
            localStorage.removeItem('assignTime');
            localStorage.removeItem('assignUrl');
            return resolve();
          } else {
            if (time < 120000) {
              time += 1000;
              localStorage.setItem('assignTime', time);
              setTimeout(() => {
                checkStatus(url);
              }, 2000);
            } else {
              localStorage.removeItem('assignTime');
              localStorage.removeItem('assignUrl');
              return reject();
            }
          }
        });
      }

      checkStatus(statusUrl);
    });
    return promise;
  };
}
export function startRun() {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/start-run/')
        .then(res => {
          toastr.info('Assignment is starting...');
          let time = +localStorage.getItem('assignTime') || 1000;

          function checkStatus(url) {
            request.req('GET', url).then(res => {
              if (res.data.status == 'success') {
                toastr.success('Assignment has started successfully!');
                localStorage.removeItem('assignTime');
                localStorage.removeItem('assignUrl');
                return resolve();
              } else {
                if (time < 120000) {
                  time += 1000;
                  localStorage.setItem('assignTime', time);
                  setTimeout(() => {
                    checkStatus(url);
                  }, 2000);
                } else {
                  localStorage.removeItem('assignTime');
                  localStorage.removeItem('assignUrl');
                  return reject();
                }
              }
            });
          }

          localStorage.setItem('assignUrl', res.data.url);
          checkStatus(res.data.url);
        })
        .catch(err => {
          console.log('ERROR', err.message);
          toastr.error('Problem with starting the Assignment.');
          return reject();
        });
    });
    return promise;
  };
}

export function continueStopRun(statusUrl) {
  return () => {
    let promise = new Promise((resolve, reject) => {
      let time = +localStorage.getItem('assignStopTime');

      function checkStatus(url) {
        request.req('GET', url).then(res => {
          if (res.data.status == 'success') {
            toastr.success('Assignment has stopped successfully!');
            localStorage.removeItem('assignStopTime');
            localStorage.removeItem('assignStopUrl');
            return resolve();
          } else {
            if (time < 120000) {
              time += 1000;
              localStorage.setItem('assignStopTime', time);
              setTimeout(() => {
                checkStatus(url);
              }, 2000);
            } else {
              localStorage.removeItem('assignStopTime');
              localStorage.removeItem('assignStopUrl');
              return reject();
            }
          }
        });
      }

      checkStatus(statusUrl);
    });
    return promise;
  };
}

export function stopRun() {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/stop-run/')
        .then(res => {
          toastr.info('Assignment is stopping...');
          let time = +localStorage.getItem('assignStopTime') || 1000;

          function checkStatus(url) {
            request.req('GET', url).then(res => {
              if (res.data.status == 'success') {
                toastr.success('Assignment has stopped successfully!');
                localStorage.removeItem('assignStopUrl');
                localStorage.removeItem('assignStopTime');
                return resolve();
              } else {
                if (time < 120000) {
                  time += 1000;
                  localStorage.setItem('assignStopTime', time);
                  setTimeout(() => {
                    checkStatus(url);
                  }, 2000);
                } else {
                  localStorage.removeItem('assignStopTime');
                  return reject();
                }
              }
            });
          }

          localStorage.setItem('assignStopUrl', res.data.url);
          checkStatus(res.data.url);
        })
        .catch(err => {
          console.log('ERROR', err.message);
          toastr.error('Problem with stopping the Assignment');
          return reject();
        });
    });
    return promise;
  };
}

export function continueGetAllocations(statusUrl) {
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      let time = +localStorage.getItem('allocationsTime');

      function checkStatus(url) {
        request.req('GET', url).then(res => {
          if (res.data.status == 'success') {
            toastr.success('Continue successfully!');
            localStorage.removeItem('allocationsTime');
            localStorage.removeItem('allocationsUrl');
            axios
              .get(res.data.output, { headers: customHeader() })
              .then(res => {
                dispatch(getAllocationsSuccess(res.data));
                return resolve();
              })
              .catch(err => {
                console.log('ERROR', err);
              });
          } else {
            if (time < 120000) {
              time += 1000;
              localStorage.setItem('allocationsTime', time);
              setTimeout(() => {
                checkStatus(url);
              }, 1000);
            } else {
              localStorage.removeItem('allocationsTime');
              localStorage.removeItem('allocationsUrl');
              return reject();
            }
          }
        });
      }

      checkStatus(statusUrl);
    });
    return promise;
  };
}

export function getAllocations(computation) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/computations/' + computation + '/get-allocation/')
        .then(res => {
          let time = +localStorage.getItem('allocationsTime') || 1000;

          function checkStatus(url) {
            request.req('GET', url).then(res => {
              if (res.data.status == 'success') {
                localStorage.removeItem('allocationsUrl');
                localStorage.removeItem('allocationsTime');
                // Get allocations from json - CORS issue

                axios
                  .get(res.data.output, { headers: customHeader() })
                  .then(res => {
                    dispatch(getAllocationsSuccess(res.data));
                    return resolve();
                  })
                  .catch(err => {
                    console.log('ERROR', err);
                  });
              } else {
                if (time < 120000) {
                  time += 1000;
                  localStorage.setItem('allocationsTime', time);
                  setTimeout(() => {
                    checkStatus(url);
                  }, 2000);
                } else {
                  localStorage.removeItem('allocationsTime');
                  return reject();
                }
              }
            });
          }

          localStorage.setItem('allocationsUrl', res.data.url);
          checkStatus(res.data.url);
        })
        .catch(err => {
          console.log('ERROR', err.message);
          toastr.error('Problem with stopping the Assignment');
          return reject();
        });
    });
    return promise;
  };
}

export function publishComputations(computationId, email_students, populate_waitlist) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/computations/' + computationId + '/finalize-assignment/', { email_students, populate_waitlist})
        .then(res => {
          return resolve(res.data);
        })
        .catch(err => {
          return reject(err.data);
        });
    });
    return promise;
  };
}

export function makeOutput(c, fileType) {
  let runName = localStorage.getItem('run');
  let data = {
    filetype: fileType
  };
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/computations/' + c + '/make-output/', data)
        .then(resId => {
          let time = +localStorage.getItem('downloadTime') || 1000;

          function getFile(data) {
            if (data.url.length > 0) {
              request.req('GET', data.url).then(res => {
                if (res.data.output.length > 0) {
                  return resolve(res.data.output);
                } else {
                  if (time < 120000) {
                    time += 1000;
                    localStorage.setItem('downloadTime', time);
                    setTimeout(() => {
                      getFile(data);
                    }, 1000);
                  } else {
                    localStorage.removeItem('downloadTime');
                    reject();
                  }
                }
              });
            } else {
              if (time < 120000) {
                time += 1000;
                localStorage.setItem('downloadTime', time);
                setTimeout(() => {
                  getFile(data);
                }, 1000);
              } else {
                localStorage.removeItem('downloadTime');
                reject();
              }
            }
          }

          // Call getFile() function to get the file
          getFile(resId.data);
        })
        .catch(err => {
          toastr.error('Computation error.');
          console.log('error', err.message);
          return reject();
        });
    });
    return promise;
  };
}

export function handleDownloadAssignment() {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
        request
        .req('POST', '/runs/' + runName + '/download-assignment/')
        .then(response => {
          if (response.status === 200) {
            return resolve(response.data);
          }
          return reject('File error');
        });
    })
    return promise;
  }
}

export const getRun = mergeRequestsWrapper(function getRun() {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    return request
      .req('GET', '/runs/' + runName + '/')
      .then(response => {
        if (response.status == 200) {
          dispatch(getRunSuccess(response));
          dispatch(getSchool(response.data.school));
          return Promise.resolve();
        }
        return Promise.reject();
      })
      .catch(err => {
        console.log(err);
        return Promise.reject();
      });
  };
})

export function continueFileUpload(statusUrl) {
  return () => {
    let promise = new Promise((resolve, reject) => {
      let time = +localStorage.getItem('uploadFileTime');

      function checkStatus(url) {
        request.req('GET', url).then(res => {
          if (res.data.status == 'success') {
            toastr.success('File uploaded successfully!');
            localStorage.removeItem('uploadFileTime');
            localStorage.removeItem('uploadFileUrl');

            return resolve();
          } else if (res.data.status == 'error') {
            toastr.error('Cannot upload file');
            localStorage.removeItem('uploadFileTime');
            localStorage.removeItem('uploadFileUrl');
            return resolve();
          } else {
            if (time < 120000) {
              time += 1000;
              localStorage.setItem('uploadFileTime', time);
              setTimeout(() => {
                checkStatus(url);
              }, 2000);
            } else {
              localStorage.removeItem('uploadFileTime');
              localStorage.removeItem('uploadFileUrl');
              return reject();
            }
          }
        });
      }

      checkStatus(statusUrl);
    });
    return promise;
  };
}

export function uploadFile(file, runName) {
  let config = {
    method: 'PUT',
    url: '/runs/' + runName + '/upload-run/',
    baseURL: baseUrl,
    data: file,
    headers: { ...customHeader(), 'Content-Disposition': 'attachment; filename=upload.xlsx' }
  };

  return () => {
    return new Promise((resolve, reject) => {
      axios
        .request(config)
        .then(res => {
          console.log(res);
          if (res.status === 200) {
            toastr.success('File uploaded successfully!');
            return resolve(res.data);
          } else {
            toastr.error('Cannot upload file');
            return reject(new Error('Cannot upload file'));
          }
        })
        .catch(err => {
          if (err.response) {
            toastr.error(err.response.data.error)
            return reject(new Error(err.message));
          }
          console.log('ERROR', err.message);
          toastr.error('Problem with file upload.');
          return reject(new Error(err.message));
        });
    });
  };
}

export function updateRun(data) {
  let runName = localStorage.getItem('run');

  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('PUT', '/runs/' + runName + '/', data)
        .then(response => {
          toastr.success('Success!');
          dispatch(getRunSuccess(response));
          return resolve();
        })
        .catch(err => {
          console.log('error', err.message);
          toastr.error('Something went wrong!');
          return reject();
        });
    });
    return promise;
  };
}

export function getRuns(role) {
  const runsUrl = role === 0 ? '/runs/student-runs/' : '/runs/dean-runs/';
  return (dispatch) => {
    function getCourses(url) {
      request
        .req('GET', url)
        .then(res => {
          console.log(res);
          dispatch(runsFetched(res.data));
        })
        .catch(err => {
          console.log('err', err);
        });
    }
    getCourses(runsUrl);
  };
}

export function searchRestrictions(term, conflicts, courses) {
  return () => {
    let b = conflicts.filter(conflict => {
      let cArray = [];
      conflict.courses.forEach(id => {
        let e = courses.filter(c => {
          return c.id == id;
        });
        e.map(f => {
          if (
            f.slug.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
            f.longname.toLowerCase().indexOf(term.toLowerCase()) != -1
          ) {
            cArray.push(f);
          }
        });
      });
      let bool = () => {
        if (cArray.length > 0) {
          return true;
        } else {
          return false;
        }
      };
      return !conflict.is_time_conflict && (bool() || conflict.name.toLowerCase().indexOf(term.toLowerCase()) != -1);
    });

    let unique = function(origArr) {
      let newArr = [],
        origLen = origArr.length,
        found,
        x,
        y;
      for (x = 0; x < origLen; x++) {
        found = undefined;
        for (y = 0; y < newArr.length; y++) {
          if (origArr[x].id === newArr[y].id) {
            found = true;
            break;
          }
        }
        if (!found) {
          newArr.push(origArr[x]);
        }
      }
      return newArr;
    };
    return unique(b);
  };
}

export const getAllRankPreferences = mergeRequestsWrapper(function getAllRankPreferences() {
  let runName = localStorage.getItem('run');
  let preferences = [];

  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      function getPreferences(url) {
        request
          .req('GET', url)
          .then(res => {
            res.data.results.forEach(pref => {
              preferences.push(pref);
            });
            if (res.data.next == null) {
              dispatch(getRankPreferencesSuccess(preferences));
              return resolve();
            } else {
              getPreferences(res.data.next);
            }
          })
          .catch(err => {
            console.log('err', err);
            return reject();
          });
      }

      getPreferences('/runs/' + runName + '/preferences/');
    });
    return promise;
  };
})
export function postRankPreferences(preferences) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    request
      .req('POST', '/runs/' + runName + '/preferences/', preferences)
      .then(() => {
        localStorage.removeItem('courses');
        localStorage.removeItem('deleted_courses');
        localStorage.removeItem('ranked_courses');
        browserHistory.push('/rank/' + runName + '/schedules');
        toastr.success('Ranking updated!');
        dispatch(getAllRankPreferences());
      })
      .catch(err => {
        console.log(err);
      });
  };
}

export function alterAddDrop(mode) {
  const runName = localStorage.getItem('run');
  const body = { mode };
  return (dispatch) => {
    request
      .req('POST', `/runs/${runName}/alter-add-drop/`, body)
      .then(response => {
        dispatch(getRunSuccess(response));
      })
      .catch(err => {
        console.log(err);
      });
  };
}

export const processWaitlist = () => {
  const runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', `/runs/${runName}/process-pending/`)
        .then(response => {
          console.log(response.data);
          return resolve(response.data);
        })
        .catch(error => {
          return reject(error.data);
        });
    });
    return promise;
  };
}

export function updatePreferencesState(preferences) {
  return (dispatch) => {
    dispatch(getRankPreferencesSuccess(preferences));
  };
}



// WEBPACK FOOTER //
// ./src/actions/runsActionCreators.js